import React from 'react'
import News from './News'

const NewsBox = () => {
  return (
    <div className='home-body'>
        <div className="content">
            <div className='ai-box'>
                <News/>
            </div>
        </div>
            
    </div>
  )
}

export default NewsBox